import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'decimalPipe' })
export class DecimalPipe implements PipeTransform {
    constructor() {}
    transform(value: number): number {
        const decimal = 1;
        const powerValue = Math.pow(10, decimal);
        return Math.floor(value * powerValue) / powerValue;
    }
}
